module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_img1.d4e1e06a.png";